import { useEffect, useState } from "react";
import { Link } from "react-router-dom";import { useContent } from "@/context/ContentContext";
import { resolveImg } from "@/lib/api";

export const Nav = ({ solid = false }) => {
  const { branding } = useContent();
  const [sc, setSc] = useState(solid);

  useEffect(() => {
    if (solid) return;
    const onScroll = () => setSc(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [solid]);

  return (
    <header className={`nav${sc ? " sc" : ""}`} data-testid="nav">
      <div className="wrap">
        <Link to="/" className="logo" data-testid="nav-logo">
          {branding?.logo_image_url ? (
            <img src={resolveImg(branding.logo_image_url)} alt={branding.logo_text || "TAANDEM"} style={{ height: 26 }} />
          ) : (
            branding?.logo_text || "TAANDEM"
          )}
        </Link>
        <ul>
          {(branding?.nav_links || []).map((l, i) => (
            <li key={i}>
              <a href={l.href?.startsWith("#") ? `/${l.href}` : l.href} data-testid={`nav-link-${i}`}>{l.label}</a>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};
